import React from 'react'

import { Row } from 'Components/shared/Container'
import { Button, InputButton } from 'Components/shared/Button'
import { navigate } from 'raviger'
import { colors } from 'Constants'
import { setSelection } from 'Store/clubs'

export default ({
  handleSaveAndQuit,
  newClient = false,
  cloned = false,
  setSelectedClub,
  setMaster,
  setSelected,
  setCustomLinks
}) => {
  return (
    <>
      <Row style={{ margin: '2em' }}>
        <InputButton type="submit" value="Save Client" />
        {!cloned && !newClient && (
          <Button
            color={colors.blueBtn}
            onClick={() => {
              setSelection({ club: {} })
              setSelectedClub({})
              setMaster({})
              setSelected(false)
              setCustomLinks([])
            }}
            style={{ margin: '1em' }}
          >
            Cancel
          </Button>
        )}
        {cloned && (
          <Button
            color={colors.blueBtn}
            onClick={() => {
              setSelection({ club: {} })
              setSelectedClub({})
              setMaster({})
              setSelected(false)
              setCustomLinks([])
            }}
            style={{ margin: '1em' }}
          >
            Cancel
          </Button>
        )}
        {newClient && (
          <>
            <Button color={colors.blueBtn} onClick={() => navigate('/')} style={{ margin: '1em' }}>
              Cancel
            </Button>
            <Button onClick={() => handleSaveAndQuit()} value="Save and Exit">
              Save and Exit
            </Button>
          </>
        )}
      </Row>
    </>
  )
}
